import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { Adv1Page } from './pages/Adv1Page';
import { Adv2Page } from './pages/Adv2Page';
import { Adv3Page } from './pages/Adv3Page';
import { GlpAdv1Page } from './pages/GlpAdv1Page';
import { GlpAdv2Page } from './pages/GlpAdv2Page';
export function AppRouter() {
  return <BrowserRouter data-id="element-20">
      <Routes data-id="element-21">
        <Route path="/" element={<App data-id="element-23" />} data-id="element-22" />
        <Route path="/adv-1" element={<Adv1Page data-id="element-25" />} data-id="element-24" />
        <Route path="/glp1-investigation" element={<Adv2Page data-id="element-27" />} data-id="element-26" />
        <Route path="/glp-adv-1" element={<GlpAdv1Page data-id="element-29" />} data-id="element-28" />
        <Route path="/glp-adv-2" element={<GlpAdv2Page data-id="element-31" />} data-id="element-30" />
        <Route path="/adv-3" element={<Adv3Page data-id="element-33" />} data-id="element-32" />
      </Routes>
    </BrowserRouter>;
}